// The way back UP from a /series/* detail page. Deep links are how most people arrive — a podcast app's show notes, a vanity redirect, a search result — so without this the show and episode pages are dead ends with no route to the directory.
// Node-prerender-safe: MUI + react-router only (see series.tsx).
import { Link as RouterLink } from 'react-router';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import MUILink from '@mui/material/Link';

/** A crumb with no `to` is the current page — rendered as text, never as a link to itself. */
export type Crumb = { label: string; to?: string };

export default function SeriesCrumbs({ items }: { items: Crumb[] }) {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      {items.map((item, i) => (item.to
        ? <MUILink key={i} component={RouterLink} to={item.to} variant="body2" color="text.secondary" underline="hover">{item.label}</MUILink>
        : <Typography key={i} variant="body2" color="text.primary">{item.label}</Typography>
      ))}
    </Breadcrumbs>
  );
}
